import { render, staticRenderFns } from "./ProductOverviewStatusDot.vue?vue&type=template&id=5b1cdcf9&scoped=true&"
import script from "./ProductOverviewStatusDot.vue?vue&type=script&lang=js&"
export * from "./ProductOverviewStatusDot.vue?vue&type=script&lang=js&"
import style0 from "./ProductOverviewStatusDot.vue?vue&type=style&index=0&id=5b1cdcf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1cdcf9",
  null
  
)

export default component.exports